import Constants from '../constants/Constants';
import CardTypes from '../constants/CardTypes';
import LocalStorage from '../../local-storage/LocalStorage';
import fb_db from '../../firebase/firebaseUse';

export default class ScoreCalculator {

    constructor(gameCtx) {
        this.gameCtx = gameCtx;

        this.setCardTypes = [
            CardTypes.CARBS_CARD,
            CardTypes.FATS_CARD,
            CardTypes.FRUITS_CARD,
            CardTypes.PROTEINS_CARD,
            CardTypes.VEGETABLES_CARD,
            CardTypes.WATER_CARD
        ];
        this.currPoints = Number(LocalStorage.getItem("score"));
    }

    isThereAWinner = () => {
        let entities = this.gameCtx.entitiesRepo.getPlayers();
        for (let i = 0; i < entities.length; i++) {
            if (this.hasFulSet(entities[i])) {
                return true;
            }
        }
        return false;
    }

    hasFulSet = (player) => {
        let [cardTypesCounter, jokerCounter] = this.getScoreData(player);
        for (let value of cardTypesCounter.values()) {
            if (value === 0) {
                if (jokerCounter > 0) {
                    jokerCounter--;
                }
                else {
                    return false;
                }
            }
        }
        return true;
    }

    addWinningBonus = (player) => {
        player.score += Constants.SCORE_WINING_BONUS;
    }

    updateScore = (player) => {
        let [cardTypesCounter, jokerCounter, protectionCounter] = this.getScoreData(player);
        let score = 0;

        for (let value of cardTypesCounter.values()) {
            if (value > 0) {
                score += Constants.SCORE_SET_CARD;
            }
        }

        score += jokerCounter * Constants.SCORE_SET_CARD;
        score += protectionCounter * Constants.SCORE_PROTECTION_CARD;
        player.score = score;
    }

    getScoreData = (player) => {
        let cards = player.getCards();
        let cardTypesCounter = new Map();
        let jokerCounter = 0;
        let protectionCounter = 0;

        this.setCardTypes.forEach(cardType => {
            cardTypesCounter.set(cardType, 0);
        });

        cards.forEach(card => {
            let cardType = card.comp.props.type;

            if (this.setCardTypes.includes(cardType)) {
                let counter = cardTypesCounter.get(cardType) + 1;
                cardTypesCounter.set(cardType, counter);
            }
            else {
                if (cardType === CardTypes.JOKER_CARD) {
                    jokerCounter++;
                }
                else {
                    if (cardType === CardTypes.ONION_GARLIC_CARD || cardType === CardTypes.CABBAGE_BROCCOLI_CARD) {
                        protectionCounter++;

                        // protection card is considered as vegetable cardType in scoring
                        let counter = cardTypesCounter.get(CardTypes.VEGETABLES_CARD) + 1;
                        cardTypesCounter.set(CardTypes.VEGETABLES_CARD, counter)
                    }
                }
            }
        });
        return [cardTypesCounter, jokerCounter, protectionCounter];
    }

    updateUserScore = (myPlayerObj) => {
        let score = myPlayerObj.score + this.currPoints;
        let playerId = localStorage.getItem("id");

        LocalStorage.setItem("score", score);
        fb_db._db.ref("users/" + playerId + "/score").set(score);
        fb_db.handleChampionsList()
    }
}